import en from '@vueform/vueform/locales/en'
import pt from '@vueform/vueform/locales/pt'
import es from '@vueform/vueform/locales/es'
import fr from '@vueform/vueform/locales/fr'
import it from '@vueform/vueform/locales/it'
import de from '@vueform/vueform/locales/de'
import bootstrap from '@vueform/vueform/dist/bootstrap'
import { defineConfig } from '@vueform/vueform'
import AudioRecorderElement from '@/components/vueform-elements/audio-recorder.vue';

export default defineConfig({
  theme: bootstrap,
  locales: { en, pt, es, fr, it, de },
  locale: 'en',
  endpoints: {
    uploadTempFile: false
  }  ,
  elements: [ AudioRecorderElement],
})